import { render, staticRenderFns } from "./ElemGoods.vue?vue&type=template&id=3d460d24&"
import script from "./ElemGoods.vue?vue&type=script&lang=js&"
export * from "./ElemGoods.vue?vue&type=script&lang=js&"
import style0 from "./ElemGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports